module.exports = __webpack_public_path__ + "static/media/loseLarge30_1.9270af43.png";